import React from "react";

export default function Payment() {
  return (
    <div
      style={{
        color: "#54616c",
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        justifyContent: "start",
        margin : "1rem",
        padding : "10px",
      }}
    >
      <h5 style={{fontSize: "20px"}}>Payment Method</h5>
      <p style={{textAlign: "left"}}>You have no payment methods configured.</p>
      <h5 style={{fontSize: "20px"}}>Billing History</h5>
      <p style={{textAlign: "left"}}>Your payment history is empty.</p>
    </div>
  );
}
